import { VIEW_MODE } from '@/app/interfaces/view-mode.enum';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Component, OnInit } from '@angular/core';
import { PqqReadOnlyFormComponent } from './pqq-read-only-form/pqq-read-only-form.component';
import { PreQualificationQuestionnaireViewComponent } from './pre-qualification-questionnaire-view/pre-qualification-questionnaire-view.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pqq',
  standalone: true,
  imports: [
    PqqReadOnlyFormComponent,
    PreQualificationQuestionnaireViewComponent,
    CommonModule,
  ],
  templateUrl: './pqq.component.html',
  styleUrl: './pqq.component.css',
})
export class PQQComponent implements OnInit {
  constructor(private projectsService: ProjectsService) {}

  isEditMode = false; // Default to View mode
  VIEW_MODE = VIEW_MODE;
  mode: VIEW_MODE = VIEW_MODE.EDIT;
  expressionData: any;

  handleViewChange($event: any) {
    this.mode = $event;
  }

  // toggleMode(event: any): void {
  //   this.mode = event.checked ? VIEW_MODE.VIEW : VIEW_MODE.EDIT;
  //   console.log('Switched to', this.mode);
  // }

  toggleMode(): void {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.mode = VIEW_MODE.EDIT;
    } else {
      this.mode = VIEW_MODE.VIEW;
    }
    console.log('Switched to', this.isEditMode ? 'Edit Mode' : 'View Mode');
  }
  clickEditProjectBrief() {
    localStorage.setItem('isEdit', String(true));
  }

  ngOnInit(): void {
    this.mode = VIEW_MODE.VIEW;
    // this.getExpressionOfInterest();
  }
  // getExpressionOfInterest() {
  //   this.projectsService.getProjectExpressions(1).subscribe({
  //     next: (data) => {
  //       this.expressionData = data.data;
  //       console.log('Expression of interest data fetched successfully:', data);
  //       if (this.expressionData.length > 0) {
  //         this.mode = VIEW_MODE.VIEW;
  //         this.isEditMode = false;
  //       } else if (this.expressionData.length === 0) {
  //         this.mode = VIEW_MODE.VIEW;
  //         this.isEditMode = false;
  //       }
  //     },
  //     error: (error) => {
  //       console.error('Error fetching expression of interest data:', error);
  //     },
  //   });
  // }
}
